import moment from "moment";

const DATE_TIME_FORMATS = [
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD HH:mm",
  "YYYY-MM-DDTHH:mm:ss",
  "YYYY-MM-DDTHH:mm:ss.SSS",
];

const TIME_FORMATS = ["HH:mm:ss", "HH:mm", "H:mm", "h:mm A", "hh:mm A"];

export const formatDisplayTime = (value) => {
  if (!value) return "";
  const text = String(value).trim();
  const hasOffset = /(?:Z|[+-]\d{2}:?\d{2})$/.test(text);
  const parsed = hasOffset
    ? moment.parseZone(text)
    : moment(text, [...DATE_TIME_FORMATS, ...TIME_FORMATS], true);
  return parsed.isValid() ? parsed.format("h:mm A") : "";
};
